import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

// SVG Icons as components
const Icons = {
  Dashboard: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
      <rect x="14" y="14" width="7" height="7" rx="1" />
    </svg>
  ),
  Upload: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="17 8 12 3 7 8" />
      <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
  ),
  Customers: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  Compare: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10" />
      <line x1="12" y1="20" x2="12" y2="4" />
      <line x1="6" y1="20" x2="6" y2="14" />
    </svg>
  ),
  Export: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  ),
  Xero: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M8 12h8" />
      <path d="M12 8v8" />
    </svg>
  ),
  Microsoft: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="8" height="8" />
      <rect x="13" y="3" width="8" height="8" />
      <rect x="3" y="13" width="8" height="8" />
      <rect x="13" y="13" width="8" height="8" />
    </svg>
  ),
  Users: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <line x1="19" y1="8" x2="19" y2="14" />
      <line x1="22" y1="11" x2="16" y2="11" />
    </svg>
  ),
  Organization: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  ),
  Profile: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Logout: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  ),
  Menu: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  ),
  Close: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  ChevronDown: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="6 9 12 15 18 9" />
    </svg>
  ),
  Ticket: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M15 5v2" />
      <path d="M15 11v2" />
      <path d="M15 17v2" />
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M3 9h18" />
      <path d="M3 15h18" />
    </svg>
  ),
  Cloud: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
    </svg>
  ),
  Shield: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  Wallet: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" />
      <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" />
      <path d="M18 12a2 2 0 0 0 0 4h4v-4z" />
    </svg>
  ),
};

function Layout({ children }: LayoutProps) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [integrationsOpen, setIntegrationsOpen] = useState(true);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path: string) => location.pathname === path;
  const isActiveGroup = (paths: string[]) => paths.some(p => location.pathname.startsWith(p));

  const isAdmin = user && (user.role === 'admin' || user.role === 'superadmin' || user.is_superuser);
  const isSuperAdmin = user && (user.role === 'superadmin' || user.is_superuser);

  // Close sidebar on route change (mobile)
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  // Close sidebar on escape key
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setSidebarOpen(false);
      }
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, []);

  return (
    <div className="layout">
      {/* Mobile Header */}
      <header className="mobile-header">
        <button
          className="menu-toggle"
          onClick={() => setSidebarOpen(!sidebarOpen)}
          aria-label="Toggle menu"
        >
          {sidebarOpen ? <Icons.Close /> : <Icons.Menu />}
        </button>
        <span className="mobile-brand">CloudViewMSP</span>
        <div className="mobile-user">
          <span className="user-avatar">{user?.email?.charAt(0).toUpperCase()}</span>
        </div>
      </header>

      {/* Sidebar Overlay (mobile) */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
          aria-hidden="true"
        />
      )}

      {/* Sidebar */}
      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <Link to="/dashboard" className="sidebar-brand">
            <div className="brand-icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                <rect width="32" height="32" rx="8" fill="currentColor" />
                <path d="M8 16C8 11.58 11.58 8 16 8C18.4 8 20.56 9.04 22 10.72V8H24V14H18V12H20.4C19.28 10.76 17.72 10 16 10C12.68 10 10 12.68 10 16C10 19.32 12.68 22 16 22C18.56 22 20.76 20.4 21.6 18H23.68C22.76 21.52 19.68 24 16 24C11.58 24 8 20.42 8 16Z" fill="white"/>
              </svg>
            </div>
            <span className="brand-text">CloudViewMSP</span>
          </Link>
        </div>

        <nav className="sidebar-nav">
          {/* Main Section */}
          <div className="nav-section">
            <Link to="/dashboard" className={`nav-item ${isActive('/dashboard') ? 'active' : ''}`}>
              <Icons.Dashboard />
              <span>Dashboard</span>
            </Link>
          </div>

          {/* Billing */}
          <div className="nav-section">
            <div className="nav-section-title">Billing</div>
            <Link to="/billing" className={`nav-item ${isActive('/billing') ? 'active' : ''}`}>
              <Icons.Customers />
              <span>💳 Invoice Prep</span>
            </Link>
            <Link to="/expenses" className={`nav-item ${isActive('/expenses') ? 'active' : ''}`}>
              <Icons.Wallet />
              <span>Expenses</span>
            </Link>
          </div>




          {/* Integrations */}
          <div className="nav-section">
            <button
              className="nav-section-toggle"
              onClick={() => setIntegrationsOpen(!integrationsOpen)}
            >
              <span>Integrations</span>
              <span className={`toggle-icon ${integrationsOpen ? 'open' : ''}`}>
                <Icons.ChevronDown />
              </span>
            </button>
            {integrationsOpen && (
              <div className="nav-section-items">
                <Link to="/integrations" className={`nav-item ${isActive('/integrations') ? 'active' : ''}`}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12a9 9 0 1 1-9-9" /><polyline points="21 3 21 9 15 9" /></svg>
                  <span>Sync & Health</span>
                </Link>
                <Link to="/xero" className={`nav-item ${isActiveGroup(['/xero']) ? 'active' : ''}`}>
                  <Icons.Xero />
                  <span>Xero</span>
                </Link>
                <Link to="/whmcs" className={`nav-item ${isActive('/whmcs') ? 'active' : ''}`}>
                  <Icons.Export />
                  <span>WHMCS</span>
                </Link>
                <Link to="/splynx" className={`nav-item ${isActive('/splynx') ? 'active' : ''}`}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12.55a11 11 0 0 1 14.08 0" /><path d="M1.42 9a16 16 0 0 1 21.16 0" /><path d="M8.53 16.11a6 6 0 0 1 6.95 0" /><line x1="12" y1="20" x2="12.01" y2="20" /></svg>
                  <span>Fibre</span>
                </Link>
                <Link to="/portaone" className={`nav-item ${isActive('/portaone') ? 'active' : ''}`}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z" /></svg>
                  <span>PortaOne VoIP</span>
                </Link>
                {/* Redstor: hidden from the menu until the RedAPI key is supplied (page still at /redstor) */}
                {isAdmin && (
                  <Link to="/microsoft365" className={`nav-item ${isActive('/microsoft365') ? 'active' : ''}`}>
                    <Icons.Microsoft />
                    <span>Microsoft 365</span>
                  </Link>
                )}
                {isAdmin && (
                  <Link to="/partner-center" className={`nav-item ${isActive('/partner-center') ? 'active' : ''}`}>
                    <Icons.Microsoft />
                    <span>365 Partner Portal</span>
                  </Link>
                )}
                {isAdmin && (
                  <Link to="/cove" className={`nav-item ${isActive('/cove') ? 'active' : ''}`}>
                    <Icons.Upload />
                    <span>Cove Backup</span>
                  </Link>
                )}
                {isAdmin && (
                  <Link to="/sentinelone" className={`nav-item ${isActive('/sentinelone') ? 'active' : ''}`}>
                    <Icons.Shield />
                    <span>SentinelOne</span>
                  </Link>
                )}
                {isAdmin && (
                  <Link to="/proxmox" className={`nav-item ${isActive('/proxmox') ? 'active' : ''}`}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="8" rx="2" /><rect x="2" y="14" width="20" height="8" rx="2" /><circle cx="6" cy="6" r="1" /><circle cx="6" cy="18" r="1" /></svg>
                    <span>Proxmox</span>
                  </Link>
                )}
                {isAdmin && (
                  <Link to="/halopsa" className={`nav-item ${isActive('/halopsa') ? 'active' : ''}`}>
                    <Icons.Ticket />
                    <span>HaloPSA</span>
                  </Link>
                )}
                {isAdmin && (
                  <Link to="/cloudblue" className={`nav-item ${isActive('/cloudblue') ? 'active' : ''}`}>
                    <Icons.Cloud />
                    <span>CloudBlue</span>
                  </Link>
                )}
              </div>
            )}
          </div>

          {/* Admin Section */}
          {isAdmin && (
            <div className="nav-section">
              <div className="nav-section-title">Administration</div>
              <Link to="/users" className={`nav-item ${isActive('/users') ? 'active' : ''}`}>
                <Icons.Users />
                <span>Users</span>
              </Link>
              <Link to="/organizations" className={`nav-item ${isActive('/organizations') ? 'active' : ''}`}>
                <Icons.Organization />
                <span>Organizations</span>
              </Link>
              {isSuperAdmin && (
                <Link to="/audit-log" className={`nav-item ${isActive('/audit-log') ? 'active' : ''}`}>
                  <span style={{fontSize: '1.1rem', width: '20px', display: 'inline-flex', justifyContent: 'center'}}>🔒</span>
                  <span>Audit Log</span>
                </Link>
              )}
            </div>
          )}
        </nav>

        {/* User Section */}
        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar-large">
              {user?.email?.charAt(0).toUpperCase()}
            </div>
            <div className="user-details">
              <span className="user-name">{user?.full_name || user?.email?.split('@')[0]}</span>
              <span className="user-role">{user?.role || 'User'}</span>
            </div>
          </div>
          <div className="user-actions">
            <Link to="/profile" className="user-action-btn">
              <Icons.Profile />
              <span>Profile</span>
            </Link>
            <button onClick={handleLogout} className="user-action-btn logout">
              <Icons.Logout />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="main-content">
        <div className="content-wrapper">
          {children}
        </div>
      </main>
    </div>
  );
}

export default Layout;
